"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTriflexR = exports.triflexRUseableDef = void 0;
const KetteSerieType_1 = require("./KetteSerieType");
const schemaVersions_1 = require("../schemaVersions");
const echain_shared_modelling_1 = require("@igus/echain-shared-modelling");
exports.triflexRUseableDef = {
    parent: schemaVersions_1.ketteLatestUseableDef,
    validation: {
        KetteSerieType: (v) => v === KetteSerieType_1.KetteSerieType.triflexR,
    },
};
exports.isTriflexR = echain_shared_modelling_1.UseableUtil.createGuard(exports.triflexRUseableDef);
//# sourceMappingURL=TriflexR.js.map